<template>
  <div class="swiper-content-item">
    <div class="content-above">
      <img class="avatar" :src="swiperItem.avatar">
      <div class="user-wrapper">
        <div>
          <span class="username">{{ swiperItem.username }}</span>
          <img class="gender-icon" :src="swiperItem.gender_icon">
        </div>
        <div class="user-desc">{{ swiperItem.user_desc }}</div>
      </div>
    </div>
    <div class="content-main" :style="{ 'background-image': `url(${swiperItem.background})` }">
      <div class="comment">{{ swiperItem.comment }}</div>
      <div class="gif-wrapper">
        <span class="tag-container">
          <span class="tag">
            <span class="tag-arrow"></span>
            <span class="tag-content">{{ swiperItem.gif_name }}</span>
          </span>
        </span>
        <img :src="swiperItem.gif" class="gif" :alt="swiperItem.gif_name">
      </div>
      <div class="gif-desc">{{ swiperItem.gif_desc }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';

export interface ISwiperItem {
  swiperItem: {
    gif: string;
    background: string;
    avatar: string;
    username: string;
    gender_icon: string;
    user_desc: string;
    comment: string;
    gif_name: string;
    gif_desc: string;
  };
}

@Component({})
export default class SliderItem extends Vue {
  @Prop(Object) swiperItem!: ISwiperItem;
}
</script>

<style lang="scss" scoped>
.swiper-content-item {
  width: 640px;
}

.content-above {
  display: flex;
  margin-bottom: -47px;
  margin-left: 25px;
  .avatar {
    width: 94px;
    height: 94px;
    margin-right: 13px;
  }
  .user-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .username {
    margin-right: 16px;
    color: #fff;
    font-size: 31px;
  }
  .gender-icon {
    display: inline-block;
    width: 24px;
  }
  .user-desc {
    color: rgba(124, 111, 103, 0.6);
    font-size: 21px;
    font-family: AlibabaPuHuiTiR;
  }
}

.content-main {
  height: 709px;
  background-size: cover;
  .gif-wrapper {
    position: relative;
    min-height: 332px;
  }
  .gif {
    width: 100%;
    padding-right: 31px;
    padding-left: 31px;
  }
  .tag-container {
    position: absolute;
    top: 34px;
    right: 31px;
  }
  .tag {
    display: flex;
  }
  .tag-arrow {
    display: inline-block;
    width: 8px;
    height: 52px;
    border-color: #c62727 #c62727 #c62727 transparent;
    border-style: solid;
    border-width: 26px 0px 26px 8px;
  }
  .tag-content {
    display: inline-block;
    height: 52px;
    padding: 0 12px;
    color: #fff;
    line-height: 52px;
    background: #c62727;
  }
  .gif-desc {
    margin-top: 28px;
    color: rgba(185, 116, 74, 0.8);
    font-size: 25px;
    font-family: PingFangSC-Regular;
    text-align: center;
  }
  .comment {
    height: 254px;
    padding-top: 74px;
    padding-right: 31px;
    padding-left: 31px;
    color: rgba(84, 53, 34, 0.8);
    font-size: 25px;
    font-family: PingFangSC-Regular;
    line-height: 36px;
  }
}
</style>
